import { render, staticRenderFns } from "./UIIcon.vue?vue&type=template&id=7419a5c6&"
import script from "./UIIcon.vue?vue&type=script&lang=ts&"
export * from "./UIIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports